import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { url } from '../../../../env';
import { formatDateTime, labelOf } from './roleConfig';

// TODO: filtro "Permisos" cuando exista endpoint de audit log de permisos
const FILTERS = [
    { key: 'all', label: 'Todos' },
    { key: 'role', label: 'Cambios de rol' },
];

const UserHistoryTab = ({ user, toast }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [history, setHistory] = useState([]);
    const [filter, setFilter] = useState('all');

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            setLoading(true);
            setError(null);
            try {
                const res = await axios.get(`${url}/users/${user.id}/role-history`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                });
                if (cancelled) return;
                const list = res.data?.data ?? res.data ?? [];
                setHistory(Array.isArray(list) ? list : []);
            } catch (e) {
                if (cancelled) return;
                console.error(e);
                setError('No se pudo cargar el historial.');
            } finally {
                if (!cancelled) setLoading(false);
            }
        };
        if (user?.id) load();
        return () => { cancelled = true; };
    }, [user?.id]);

    if (loading) {
        return (
            <div className="udm-loading">
                <i className="pi pi-spin pi-spinner" />
                <span>Cargando historial...</span>
            </div>
        );
    }

    if (error) {
        return (
            <div className="udm-loading">
                <i className="pi pi-exclamation-triangle" style={{ color: '#ef4444' }} />
                <span>{error}</span>
            </div>
        );
    }

    // Both filters currently show role-changes (the only kind we have).
    const visible = history;

    return (
        <div>
            <div className="udm-history-filters">
                {FILTERS.map((f) => (
                    <button
                        key={f.key}
                        type="button"
                        className={`udm-filter-chip ${filter === f.key ? 'udm-filter-chip--active' : ''}`}
                        onClick={() => setFilter(f.key)}
                    >
                        {f.label}
                    </button>
                ))}
            </div>

            {visible.length === 0 ? (
                <div className="udm-empty-tab">
                    <i className="pi pi-clock" />
                    <span>Sin actividad registrada</span>
                </div>
            ) : (
                <div className="udm-timeline">
                    {visible.map((ev) => {
                        const fromLabel = ev.from_label ?? labelOf(ev.from_type_user);
                        const toLabel = ev.to_label ?? labelOf(ev.to_type_user);
                        return (
                            <div key={ev.id} className="udm-timeline-item">
                                <span className="udm-timeline-dot" />
                                <div className="udm-timeline-head">
                                    <span className="udm-timeline-title">
                                        Cambio de rol: {fromLabel}
                                        <span className="udm-timeline-arrow">→</span>
                                        {toLabel}
                                    </span>
                                    <span className="udm-timeline-date">
                                        {formatDateTime(ev.changed_at)}
                                    </span>
                                </div>
                                <div className="udm-timeline-actor">
                                    Por {ev.changed_by_name ?? 'Sistema'}
                                </div>
                                {ev.reason && (
                                    <div className="udm-timeline-reason">{ev.reason}</div>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default UserHistoryTab;
